export * from './Detail'
